export default __webpack_public_path__ + "static/media/Logo.86a0475f.svg";